import React from 'react';
import { ButtonProps } from 'antd/lib/button';
import CcCluster from '../../../services/models/CcCluster';
import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import ProxySqlExportConfigFrom from './ProxySqlExportConfigFrom';
import ButtonWithForm from '../../../common/General/ButtonWithForm';
import JobActionButton from '../../Jobs/JobActionButton';

export default ProxySqlExportConfigButton;

export type ProxySqlExportConfigButtonProps = ButtonProps & {
    cluster: CcCluster;
    children?: React.ReactNode;
    onSuccess?: () => void;
};

function ProxySqlExportConfigButton({
    cluster,
    children,
    onSuccess,
    ...rest
}: ProxySqlExportConfigButtonProps) {
    return (
        <ButtonWithForm
            button={
                <JobActionButton
                    command={
                        CmonJobInstanceCommand.PROXYSQL.toLowerCase() as CmonJobInstanceCommand
                    }
                    clusterId={cluster?.clusterId}
                    {...rest}
                >
                    {children || 'Export configuration'}
                </JobActionButton>
            }
            form={
                <ProxySqlExportConfigFrom
                    cluster={cluster}
                    onSuccess={onSuccess}
                />
            }
        />
    );
}
